// extracted by mini-css-extract-plugin
module.exports = {"sideNavBar":"SideNavBar_sideNavBar__16P78","navTop":"SideNavBar_navTop__1lXlT","navBottom":"SideNavBar_navBottom__3Rv-H","logo":"SideNavBar_logo__1ygVn"};